import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiTableSortLabel from '@material-ui/core/TableSortLabel';

const styles = () => ({
  root: {
  },
  head: {
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
});
const TableSortLabel = (props) => {
  const {
    classes, order, orderBy, property,
  } = props;
  return (
    <MuiTableSortLabel
      classes={{
        root: classes.root,
        head: classes.head,
      }}
      {...props}
      active={orderBy === property}
      direction={orderBy === property ? order : 'asc'}
    >
      {props.children}
      {orderBy === property ? (
        <span className={classes.visuallyHidden}>
          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
        </span>
        ) : null}
    </MuiTableSortLabel>
  );
};

export default withStyles(styles)(TableSortLabel);
